import { useQuery } from 'react-query'
import { Get } from 'src/apis/apiWithType'
import { CrowDocItem, ResponseFullVisa, ResponseType, ResponseTypeDoc, Visa, VisaItemType } from 'src/types'
import { create } from 'zustand'

interface DataType {
    selectedVisa?: Visa,
    step: 'SELECT_VISA' | 'DOCK_SHIP' | 'UPLOAD_DOCS' | 'FLIGHT' | 'PAY' | 'SUCCESS',
    currentVisaSteps: Array<DataType['step']>
    record?: { docs: CrowDocItem[], data: VisaItemType }

}


interface StoreType extends DataType {
    dispatch: (data: Partial<DataType>) => void,
    forward: Function,
    back: Function,
    selectVisa: (visa: DataType['selectedVisa'], record: DataType['record']) => void,
    // isStepPassed 
}

export const useVisaRegister = create<StoreType>((set) => ({
    step: 'SELECT_VISA',
    dispatch: (newData) => set((state) => ({ ...state, ...newData })),
    currentVisaSteps: [],
    forward: () => set((state) => {

        const indexOfCurrent = state.currentVisaSteps.findIndex(i => i == state.step)

        const nextStep = state.currentVisaSteps[indexOfCurrent + 1]

        return ({ ...state, step: nextStep })
    }),
    back: () => set((state) => {

        const indexOfCurrent = state.currentVisaSteps.findIndex(i => i == state.step)

        const prevStep = state.currentVisaSteps[indexOfCurrent - 1]

        return ({ ...state, step: prevStep })
    }),
    selectVisa: (visa, record) => set((state) => {

        if (visa) {
            let roadMap: DataType['currentVisaSteps'] = ['SELECT_VISA']

            if (visa.need_dock_and_ships)
                roadMap.push('DOCK_SHIP')
            if (visa.need_fly)
                roadMap.push('FLIGHT')
            roadMap.push('UPLOAD_DOCS', 'PAY', 'SUCCESS')

            console.log({ roadMap })

            return ({ ...state, selectedVisa: visa, currentVisaSteps: roadMap, step: roadMap[1], record })
        }
        return state

    }),
}))



export const useVisaInfo = (id?: string) => useQuery<ResponseFullVisa<CrowDocItem[], VisaItemType>>({
    queryFn: ({ queryKey }) => Get(`agent/visas/show/${queryKey[1]}`) as any,
    queryKey: ['GetVisaSingle', id],
    enabled: !!id
})